import React from 'react';
import PasswordPage from '../../features/password/PasswordPage';
export default function PasswordChange() {
  return <PasswordPage mode="change" />;
}
